<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import OmniSelect from "@/components/selects/OmniSelect.vue";
import { BillingMethodEnum } from "@/api/billing/dto/invoice";

const { t } = useI18n();

const model = defineModel<BillingMethodEnum | null>({ default: null });

const props = withDefaults(
  defineProps<{
    label?: string;
    clearable?: boolean;
  }>(),
  {
    label: "",
    clearable: false,
  },
);

const items = computed(() => {
  return Object.values(BillingMethodEnum).map((method) => ({ id: method, name: t(`billing.payment-types.${method}`) }));
});
</script>

<template>
  <omni-select
    v-model="model"
    :clearable="props.clearable"
    :items="items"
    :label="props.label || t('billing.billing-method')"
    data-qa="billing-method-select"
  />
</template>
